import React from 'react';

// Page-local table feedback: a failed request must never read as an empty catalog.
export function CatalogFeedback({ busy, failed, total, matches, onRetry, onClear }: {
  busy: boolean;
  failed: boolean;
  total: number;
  matches: number;
  onRetry: () => void;
  onClear: () => void;
}) {
  if (busy) return <tr><td colSpan={5} role="status">Loading AI Fence catalog…</td></tr>;
  if (failed) return (
    <tr><td colSpan={5}>
      <p role="alert">Could not load the AI Fence catalog. Retry to request it again.</p>
      <button type="button" onClick={onRetry}>Retry catalog</button>
    </td></tr>
  );
  if (total === 0) return (
    <tr><td colSpan={5}>
      <p>No AI Fence models found. Refresh to check again.</p>
      <button type="button" onClick={onRetry}>Refresh catalog</button>
    </td></tr>
  );
  if (matches === 0) return (
    <tr><td colSpan={5}>
      <p>No matching AI Fence models. Clear the filter to see the catalog.</p>
      <button type="button" onClick={onClear}>Clear filter</button>
    </td></tr>
  );
  return null;
}
